export default __webpack_public_path__ + "static/media/configure.e742c888.svg";